import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringNotes } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';

import { INetworkElementNoteDTO } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_NOTES } from '@constants/queryKeys';

export interface IUseQueryNetworkElementNoteReturn {
	networkElementNote: string;
	isLoadingNetworkElementNote: boolean;
}

export const useQueryNetworkElementNote = (params: INetworkElementNoteDTO): IUseQueryNetworkElementNoteReturn => {
	const {
		data,
		isFetching,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_NOTES, params],
		queryFn: extractQueryParams(getChangeMonitoringNotes),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
			EUserRoles.networkOperatorCmModuleViewer,
		],
		enabled: [!!params?.networkElementId, !!params?.groupNumber],
		...refetchOptions,
	});

	return {
		networkElementNote: data?.note || '',
		isLoadingNetworkElementNote: isFetching || isInitialLoading,
	};
};

export default useQueryNetworkElementNote;
